import * as Yup from 'yup';
import { useSnackbar } from 'notistack';
import axios from 'axios';
import { useNavigate} from 'react-router-dom';
// import { useState } from 'react';
// form
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { styled } from '@mui/material/styles';
// @mui
import { Stack, Card, Typography, Container } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import useSettings from '../../../hooks/useSettings';
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import { FormProvider, RHFTextField } from '../../../components/hook-form';
import Page from '../../../components/Page';
// import HeaderBreadcrumbs from '../../../components/HeaderBreadcrumbs';

// ----------------------------------------------------------------------



const RootStyle = styled('div')(({ theme }) => ({
    display: 'flex',
    minHeight: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(12, 0),
  }));
export default function AccountChangePassword() {
  const navigate = useNavigate();
  const { themeStretch } = useSettings();
  const { enqueueSnackbar } = useSnackbar();
  const userId = localStorage.getItem("iddd");


  

  const ChangePassWordSchema = Yup.object().shape({
   
    newPassword: Yup.string().min(8, 'Password must be at least 8 characters').required('New Password is required'),
    confirmNewPassword: Yup.string().oneOf([Yup.ref('newPassword'), null], 'Passwords must match'),

  });

  const defaultValues = {
  
    newPassword: '',
    confirmNewPassword: '',

  };

  const methods = useForm({
    resolver: yupResolver(ChangePassWordSchema),
    defaultValues,
  });

  const {
    // reset,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = async (data) => {
 
    try {

        const response =  await axios
        .post(`${process.env.REACT_APP_API_URL}/web_register/change-password`,
        {
        
          change_password:data.newPassword,
          confirm_password:data.confirmNewPassword,
           user_id:userId,
          
        });
    
         
      
        if (!response.data.message) 
        {
     
          enqueueSnackbar(response.data.message);
        } 
       
        else {
         
          enqueueSnackbar('Password Successfully Changed !');
          navigate(PATH_DASHBOARD?.general?.app);
         

        }

    } catch (e) {
      enqueueSnackbar(e);

    }
  };

  return (
    <Page title="User: Password Settings">
        <RootStyle>
    <Container sx={{ p: 3 }} maxWidth={themeStretch ? false : 'lg'}>
    <Card sx={{ p: 3 }}>
      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Typography variant="h3" paragraph>
                  Password
                </Typography>
        <Stack spacing={3} alignItems="flex-end">
         <RHFTextField name="newPassword" type="password" label="New Password" />

          <RHFTextField name="confirmNewPassword" type="password" label="Confirm New Password" />

          <LoadingButton type="submit" variant="contained" loading={isSubmitting}>
            Save Changes
          </LoadingButton>
        </Stack>
      </FormProvider>
    </Card>
    </Container>
    </RootStyle>
    </Page>
  );
}
